import useAllLabelsMutations from "features/labels/datahooks/useAllLabelsMutations";

import { Button } from "common/components/ui/Button";
import { DialogFooter, DialogHeader } from "common/components/ui/Dialog";
import { DrawerFooter, DrawerHeader } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import type { LabelType } from "../../types";

export default function DeleteLabel({
  labelType,
  labelId,
  onBack,
}: {
  labelId: string;
  onBack: () => void;
  labelType: LabelType;
}) {
  const isDesktop = useTwBreakpoint("lg");

  const { deleteLabel, isDeletingLabel } = useAllLabelsMutations(labelType);

  function onDelete() {
    deleteLabel({ labelId }).then(() => {
      onBack();
    });
  }
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <>
      <Header
        title="Delete label"
        subtitle={
          <>
            Deleting this label will remove it from all{" "}
            {labelType.toLowerCase()}s it is currently applied to. This cannot
            be changed later. Are you sure you want to proceed?
          </>
        }
      />

      <Footer className="justify-end">
        <Button
          onClick={onBack}
          variant="secondary-black"
          disabled={isDeletingLabel}
        >
          Cancel
        </Button>

        <Button
          onClick={onDelete}
          variant="outline-danger"
          isLoading={isDeletingLabel}
          data-cy="delete-label-button"
        >
          Delete
        </Button>
      </Footer>
    </>
  );
}
